import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../../../components/Loader/Loader';
import SelectFild from '../../../../../components/SelectFild/SelectFild';
import { postWhatOccurredStore, getHazardTypes } from '../../../../../apiservices/ApiServices';
import { Row, Col } from 'react-bootstrap';
import UploadWithSignature from '../../../../../components/UploadWithSignature/UploadWithSignature';

const JetBlastRelated = ({ details, selectedCheckboxes, postUpdateData, aircraftTypes, airlineOperators, airport, aircraftRegistration, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [hazardOptions, setHazardOptions] = useState("");
    const [preImg, setPreImg] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);


    const getHazardTypeOptions = async () => {
        try {
            const res = await getHazardTypes();
            setHazardOptions(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    useEffect(() => {
        getHazardTypeOptions();
    }, []);


    const initialValues = {
        id: '',
        hazardType: "",
        timeObserved: "",
        aircraftInvolved: "",

        aircraftResCode: "",
        aircraftResNumber: "",
        aircraftType: "",
        airlineOperator: "",
        origin: '',
        destination: '',
        flightNumber: "",
        operationalImpact: "",

        uploadedFiles: [],
    };

    useEffect(() => {
        if (details?.what_occurred?.details?.["5"]?.[0]) {
            const detailItem = details.what_occurred.details["5"][0];
            const parsedData = JSON.parse(detailItem.data_json)?.[0] || {};

            setPreImg(detailItem.image_json);

            formik.setValues({
                id: detailItem.id || '',
                hazardType: parsedData.hazardType || '',
                timeObserved: parsedData.timeObserved || '',
                aircraftInvolved: parsedData.aircraftInvolved || 'no',

                aircraftResCode: parsedData.aircraftResCode || '',
                aircraftResNumber: parsedData.aircraftResNumber || '',
                aircraftType: parsedData.aircraftType || '',
                airlineOperator: parsedData.airlineOperator || '',
                origin: parsedData.origin || '',
                destination: parsedData.destination || '',
                flightNumber: parsedData.flightNumber || '',
                operationalImpact: parsedData.operationalImpact || '',
            });
        }
    }, [details]);

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: "",
        onSubmit: async (values) => {
            const selectedCatList = JSON.stringify(selectedCheckboxes);

            let param;

            if (values.aircraftInvolved == 'yes') {
                param = {
                    "hazardType": values.hazardType,
                    "timeObserved": values.timeObserved,
                    "aircraftInvolved": values.aircraftInvolved,

                    "aircraftResCode": values.aircraftResCode,
                    "aircraftResNumber": values.aircraftResNumber,
                    "aircraftType": values.aircraftType,
                    "airlineOperator": values.airlineOperator,
                    "origin": values.origin,
                    "destination": values.destination,
                    "flightNumber": values.flightNumber,
                    "operationalImpact": values.operationalImpact,
                };
            }
            else {
                param = {
                    "hazardType": values.hazardType,
                    "timeObserved": values.timeObserved,
                    "aircraftInvolved": values.aircraftInvolved,
                };
            }


            const formData = new FormData();
            formData.append('category_data', selectedCatList);

            formData.append('what_occurred_detail_id', details?.what_occurred?.details?.["5"]?.[0]?.id || '');
            formData.append('incident_header_id', details.header_id);
            const main_category = 5;
            const sub_category = selectedCheckboxes["5"];
            formData.append('category_id', main_category);

            formData.append('what_occurred_header_id', details?.what_occurred?.id);
            formData.append('sub_category_id', JSON.stringify(sub_category));

            const data_json = [];
            data_json.push(param);
            formData.append('data_json', JSON.stringify(data_json));

            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append('images[]', file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('images[]', blob, `signature_${file.originalFile.name}`);
                }
            });

            setLoadings(true);
            try {
                const res = await postWhatOccurredStore(formData);
                console.log("res", res.data);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched, } = formik;
    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };
    return (
        <>
            <div className="form-box">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="GroupList fieldset">
                        <div className='toggle-button'>
                            <h2 className="listTitle">
                                Jet Blast / Wildlife / FOD / Visual Hazards
                            </h2>
                            <div className="btnColaps">
                                <FaChevronUp />
                            </div>
                        </div>
                        <div className="subFilds">
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Type of Hazard</label>
                                        <SelectFild
                                            Firstop="Select Aircraft Type"
                                            selectName='hazardType'
                                            options={hazardOptions}
                                            value={values.hazardType}
                                            onChange={(selectedOption) => setFieldValue("hazardType", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.hazardType && touched.hazardType && (
                                            <p className="errormsg">{errors.hazardType}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Time Observed</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="timeObserved"
                                            value={values.timeObserved}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Aircraft Involved?</label>
                                        <SelectFild
                                            Firstop="Select Aircraft Involved?"
                                            selectName='aircraftInvolved'
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.aircraftInvolved}
                                            onChange={(selectedOption) => setFieldValue("aircraftInvolved", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.aircraftInvolved && touched.aircraftInvolved && (
                                            <p className="errormsg">{errors.aircraftInvolved}</p>
                                        )}
                                    </div>
                                </Col>

                                {values.aircraftInvolved == 'yes' && (
                                    <>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Aircraft Registration</label>
                                                <div className='selectwith_input'>
                                                    <div className='selects'>
                                                        <SelectFild
                                                            Firstop='Select'
                                                            selectName="aircraftResCode"
                                                            options={aircraftRegistration}
                                                            value={values.aircraftResCode}
                                                            onChange={(selectedOption) => setFieldValue("aircraftResCode", selectedOption?.value || "")}
                                                            onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="aircraftResNumber"
                                                        value={values.aircraftResNumber}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                                {errors.aircraftResCode && touched.aircraftResCode && (
                                                    <p className="errormsg">{errors.aircraftResCode}</p>
                                                )}
                                                {errors.aircraftResNumber && touched.aircraftResNumber && (
                                                    <p className="errormsg">{errors.aircraftResNumber}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="Aircraft_Type">Aircraft Type</label>
                                                <SelectFild
                                                    Firstop="Select Aircraft Type"
                                                    selectName="aircraftType"
                                                    options={aircraftTypes}
                                                    value={values.aircraftType}
                                                    onChange={(selectedOption) => setFieldValue("aircraftType", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.aircraftType && touched.aircraftType && (
                                                    <p className="errormsg">{errors.aircraftType}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="Airline_Operator">Airline / Operator</label>
                                                <SelectFild
                                                    Firstop="Select Airline / Operator"
                                                    selectName="airlineOperator"
                                                    options={airlineOperators}
                                                    value={values.airlineOperator}
                                                    onChange={(selectedOption) => setFieldValue("airlineOperator", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.airlineOperator && touched.airlineOperator && (
                                                    <p className="errormsg">{errors.airlineOperator}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Origin</label>
                                                <SelectFild
                                                    Firstop="Select Origin"
                                                    selectName="origin"
                                                    options={airport}
                                                    value={values.origin}
                                                    onChange={(selectedOption) => setFieldValue("origin", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.origin && touched.origin && (
                                                    <p className="errormsg">{errors.origin}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Destination</label>
                                                <SelectFild
                                                    Firstop="Select Origin"
                                                    selectName="destination"
                                                    options={airport}
                                                    value={values.destination}
                                                    onChange={(selectedOption) => setFieldValue("destination", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.destination && touched.destination && (
                                                    <p className="errormsg">{errors.destination}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Flight Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="flightNumber"
                                                    value={values.flightNumber}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Operational Impact (delay/diversion)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="operationalImpact"
                                                    value={values.operationalImpact}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </Row>

                            <UploadWithSignature onFilesChange={setUploadedFiles} />

                            <div className='previewsimges'>
                                {preImg.map((fileUrl, index) => {
                                    if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                        return (
                                            <div key={index} className='imageboxs'>
                                                <div className='imgs pdfs'>
                                                    <div>
                                                        <div className="pdf-icon">
                                                            <FaFilePdf size={48} color="#e74c3c" />
                                                        </div>
                                                        <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={index} className='imageboxs'>
                                            <div className='imgs'>
                                                <img src={fileUrl} alt={`Image ${index + 1}`} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="button-boxs grid pt-2 pb-2">
                                <button type="submit" className="btn btn-orange">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default JetBlastRelated